import {injectable} from "tsyringe";
import {RenameKeywordCommand} from "../commands/rename-keyword.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {Keyword} from "../domain/entities/keyword.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: RenameKeywordCommand,
    target: `dto`
})
export class RenameKeywordCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Keyword> {

    protected async toDTO(keyword: Keyword): Promise<DataTransferObject> {
        return {
            uid: keyword.uid,
            key: keyword.key,
            shortcut: keyword.shortcut,
        };
    }
}